import { TrailMapResponse } from '../../models/TrailMapResponse.model'
import FlowfeedApiQueryService, {
  FlowfeedApiQueryServiceGetEvent,
} from '../FlowfeedApiQueryService/FlowfeedApiQueryService'

export class TrailWayService {
  /**
   * @description Get comprehensive trail map data including trail info, obstructions, and geometry
   *
   * @param trailId
   *
   * @returns promise for TrailMapResponse
   */
  public async getTrailMap({ trailId }: { trailId: number }): Promise<TrailMapResponse> {
    const flowfeedApiQueryRequest: FlowfeedApiQueryServiceGetEvent = {
      endpoint: `trail-map/${trailId}`,
    }

    const flowfeedApiQueryService = new FlowfeedApiQueryService()
    try {
      const trailMapResponse = await flowfeedApiQueryService.get<TrailMapResponse>(flowfeedApiQueryRequest)
      return trailMapResponse
    } catch (error) {
      console.error(error)
      throw 'Sorry, there was a problem with your request.'
    }
  }

  /**
   * @description Force the API to re-fetch the trail's geometry from OpenStreetMap
   * (bypassing the cache), then return the refreshed trail map data. Backs the
   * admin "Refresh" action so an OSM edit can be pulled in on demand.
   *
   * @param trailId
   *
   * @returns promise for the refreshed TrailMapResponse
   */
  public async refreshTrailMap({ trailId }: { trailId: number }): Promise<TrailMapResponse> {
    const flowfeedApiQueryService = new FlowfeedApiQueryService()
    try {
      return await flowfeedApiQueryService.post<TrailMapResponse>({
        endpoint: `trail-map/${trailId}/refresh`,
      })
    } catch (error) {
      console.error(error)
      throw 'Sorry, there was a problem refreshing the trail map.'
    }
  }

  /**
   * @description Legacy method for backward compatibility - now returns TrailMapResponse
   * @deprecated Use getTrailMap instead
   */
  public async get({ trailId }: { trailId?: number }): Promise<TrailMapResponse> {
    if (!trailId) {
      throw 'Trail ID is required'
    }
    return this.getTrailMap({ trailId })
  }
}
